/**
 * RT-17612: Google cuts titles off at roughly 60 characters.
 */
export const MAX_TITLE_LENGTH = 60;

// The " | Reebelo <country>" ending every localized title template shares.
const SITE_NAME_SUFFIX = /\s\|\sReebelo\b[^|]*$/;

/**
 * Drops the " | Reebelo <country>" ending from a title that would otherwise
 * run past MAX_TITLE_LENGTH, so the product or category name is what shows.
 *
 * Titles that fit keep the ending unchanged: it is the site name Google
 * reads (see lib/site-name.ts), so it is removed, never shortened.
 */
export const fitPageTitle = (title: string): string =>
  title.length > MAX_TITLE_LENGTH ? title.replace(SITE_NAME_SUFFIX, '') : title;
